//src/pages/LoginPage.tsx
import React, { useState, useLayoutEffect } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'app/hooks';
import { usePageTitle } from 'app/hooks';
import { setUser } from 'features/auth/authSlice';
import { api } from 'services/api';
import GoogleLoginButton from 'components/Auth/GoogleLoginButton';
import YandexLoginButton from 'components/Auth/YandexLoginButton';

import styles from './styles.module.scss';

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  usePageTitle('Авторизация - Wizex');

  useLayoutEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(1));
    const accessToken = params.get('access_token');
    const provider = params.get('state');

    if (accessToken) {
      setIsLoading(true);
    }
    if (!accessToken || !provider) return;
    const endpoint = provider === 'google' ? 'auth/google' : 'auth/yandex';

      (async () => {
        try {
          const response = await api(endpoint, {
            method: 'POST',
            credentials: 'include',
          }, accessToken);

          const data = await response.json();
          localStorage.setItem('access_token', data.access_token);
          dispatch(setUser(data.user));
          navigate('/vacancies');
        } catch (error) {
          console.error(`Auth failed for ${provider}:`, error);
        }
      })();
  }, [dispatch, navigate]);

  return (
    <div className={styles.wrapper}>
      {!isLoading && (
        <div className={styles.column}>
          <div className={styles.loginButtons}>
            <h2>Wizex</h2>
            <p className={styles.loginDescription}>Авторизуйтесь в один клик</p>
            <GoogleLoginButton />
            <YandexLoginButton />
            <p className={styles.loginRules}>
              Нажимая «Войти», вы принимаете условия использования&nbsp;
              <a href="https://wizex.io/employer-agreement" target='_blank' rel="noreferrer">условия использования</a> и <a href="https://wizex.io/privacy-policy" target='_blank' rel="noreferrer">политику конфиденциальности</a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
